<template>
  <div class="content">
    <!--        <link-->
    <!--                rel="stylesheet"-->
    <!--                href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"-->
    <!--        />-->
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 flt-stats-card stat-card">
        <stats-card data-background-color="blue">
          <template slot="header">
            <i class="flaticon-security-man flaticon-hr"></i>
          </template>
          <template slot="content">
            <p class="category">Secured Accounts</p>
            <h3 class="title">{{ stats.total }}</h3>
          </template>
        </stats-card>
      </div>
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 flt-stats-card stat-card">
        <stats-card data-background-color="orange">
          <template slot="header">
            <i class="flaticon-delete-contact-symbol-for-interface flaticon-hr"></i>
          </template>
          <template slot="content">
            <p class="category">Deleted Accounts</p>
            <h3 class="title">{{ stats.deleted }}</h3>
          </template>
        </stats-card>
      </div>
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 flt-stats-card stat-card">
        <stats-card data-background-color="green">
          <template slot="header">
            <i class="flaticon-personal-configuration flaticon-hr"></i>
          </template>
          <template slot="content">
            <p class="category">Enrolling Accounts</p>
            <h3 class="title">{{ stats.notEnrolled }}</h3>
          </template>
        </stats-card>
      </div>
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 flt-stats-card stat-card">
        <stats-card data-background-color="red">
          <template slot="header">
            <i class="flaticon-businessman-wearing-tie-with-exclamation-mark flaticon-hr"></i>
          </template>
          <template slot="content">
            <p class="category">Inactive Accounts</p>
            <h3 class="title">{{ stats.inactive }}</h3>
          </template>
        </stats-card>
      </div>

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-75">
        <md-card>
          <md-card-header data-background-color="purple">
            <div class="md-layout md-alignment-center-space-between">
              <h4 class="title">Users</h4>
              <div style="display: flex">
                <md-button v-if="!isViewerAdmin" class="md-icon-button md-dense refresh-btn" @click="addNewUser">
                  <md-tooltip md-direction="top">Add new user</md-tooltip>
                  <md-icon>person_add</md-icon>
                </md-button>
                <md-button class="md-icon-button md-dense refresh-btn" @click="refreshUsers(true)">
                  <md-tooltip md-direction="top">Download Users List</md-tooltip>
                  <md-icon>file_download</md-icon>
                </md-button>
                <search-box v-model="search" @doSearch="doSearch"></search-box>
                <md-button class="md-icon-button md-dense refresh-btn" @click="refreshUsers">
                  <md-tooltip md-direction="top">Refresh users</md-tooltip>
                  <md-icon>refresh</md-icon>
                </md-button>
              </div>
            </div>

            <p v-if="totalUsers === 1" class="category">{{ totalUsers }} User</p>
            <p v-else class="category">{{ totalUsers }} Users</p>
          </md-card-header>
          <md-card-content>
            <div>
              <md-table v-model="users" table-header-color="purple" md-card>
                <md-table-row
                  class="cursor-pointer"
                  slot="md-table-row"
                  slot-scope="{ item }"
                  @click="userDetails(item.id)"
                >
                  <md-table-cell md-label="UserID">{{ item.userID }} </md-table-cell>
                  <md-table-cell md-label="Username">{{ item.application_username }} </md-table-cell>
                  <md-table-cell md-label="Application">{{ item.application_name }} </md-table-cell>
                  <md-table-cell md-label="Is active?" class="is-active">
                    <md-icon v-if="item.isActive">done</md-icon>
                    <md-icon v-else>remove</md-icon>
                  </md-table-cell>
                  <md-table-cell v-if="!isViewerAdmin" md-label="Actions" class="is-active">
                    <md-button
                      v-if="!item.isActive && !item.application_username.startsWith('DT-') && !isViewerAdmin"
                      class="md-icon-button"
                      @click.stop="enrollUser(item.id)"
                    >
                      <md-tooltip md-direction="top">Enroll user</md-tooltip>
                      <md-icon>qr_code</md-icon>
                    </md-button>
                    <md-button
                      v-if="item.state !== 'DT' && !isViewerAdmin"
                      class="md-icon-button"
                      @click.stop="deleteUser(item.id)"
                    >
                      <md-tooltip md-direction="top">Delete user</md-tooltip>
                      <md-icon>delete</md-icon>
                    </md-button>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </div>
            <div class="md-layout md-alignment-center">
              <pagination v-model="usersPage" :page-count="totalPages" @input="changePage"></pagination>
            </div>
          </md-card-content>
        </md-card>
      </div>

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-25">
        <md-card>
          <md-card-header data-background-color="orange" class="md-layout">
            <h4 class="title filter-by">
              Filter By
              <md-button class="md-icon-button md-dense" @click="removeFilters('all')" v-if="removeAll">
                <md-icon>clear</md-icon>
              </md-button>
            </h4>
          </md-card-header>
          <md-card-content class="filters">
            <md-list>
              <div v-if="searched">
                <md-subheader class="filter-radio">
                  Search
                  <md-button class="md-icon-button md-dense" @click="removeFilters('search')" v-if="searched">
                    <md-icon>clear</md-icon>
                  </md-button>
                </md-subheader>
                <md-radio v-model="searched" :value="searched">{{ searched }} </md-radio>
              </div>
              <md-divider v-if="searched"></md-divider>
              <md-subheader class="filter-radio">
                State
                <md-button class="md-icon-button md-dense" @click="removeFilters('state')" v-if="stateRadio">
                  <md-icon>clear</md-icon>
                </md-button>
              </md-subheader>
              <md-radio v-model="stateRadio" value="EG"> Enrolling</md-radio>
              <md-radio v-model="stateRadio" value="ED"> Enrolled</md-radio>
              <md-radio v-model="stateRadio" value="DT"> Deleted</md-radio>
              <md-radio v-model="stateRadio" value="AC"> Active</md-radio>
              <md-divider></md-divider>
              <md-subheader class="filter-radio md-layout">
                <div class="md-layout-item no-padding">Applications</div>
                <div class="md-layout-item no-padding">
                  <md-button
                    class="md-icon-button md-dense"
                    @click="removeFilters('applicationID')"
                    v-if="applicationRadio"
                  >
                    <md-icon>clear</md-icon>
                  </md-button>
                  <on-off-button
                    active-tooltip-message="Hide deleted applications"
                    inactive-tooltip-message="Show deleted applications"
                    @click="showHideDeletedApplications"
                  ></on-off-button>
                </div>
              </md-subheader>
              <transition-group name="fade">
                <div v-for="application in applications" :key="application.pk">
                  <md-radio v-model="applicationRadio" :value="application.pk">{{ application.name }} </md-radio>
                </div>
              </transition-group>
            </md-list>
          </md-card-content>
        </md-card>
      </div>
    </div>
    <create-new-user v-if="!isViewerAdmin" :show="showAddUser" @close="userCreated"></create-new-user>
    <enroll-application-user
      v-if="!isViewerAdmin"
      @close="userEnrolled"
      :application_user_pk="enrollUserData.currentApplicationUserPK"
      :show="enrollUserData.showEnrollUser"
    ></enroll-application-user>
    <delete-user
      v-if="!isViewerAdmin"
      @deleted="userDeleted"
      @failed="operationFailed"
      @close="deleteUserData.showDeleteUser = false"
      :application_user_pk="deleteUserData.currentApplicationUserPK"
      :show="deleteUserData.showDeleteUser"
    ></delete-user>
    <create-new-device
      v-if="!isViewerAdmin"
      :application_user_id="enrollUserData.currentApplicationUserPK"
      :show="createDevice"
      @close="onCloseCreateDevice"
    ></create-new-device>
    <waiting-for-server
      :show="showWaitingForServerDialog"
      @close="showWaitingForServerDialog = false"
      title="Exporting..."
      button="OK"
      message="We are currently in the process of generating the CSV file related to your query. Once the file is prepared, you will receive a notification in the notification section."
    ></waiting-for-server>
  </div>
</template>

<script>
import { ref, onMounted, onUpdated, computed } from "@vue/composition-api";
import fetchErrorHandler from "../../error.js";
import { Pagination } from "@/components";
import { StatsCard } from "@/components";
import { CreateNewUser } from "@/components";
import { EnrollApplicationUser } from "@/components";
import SearchBox from "../../components/SearchBox";
import DeleteUser from "@/components/DeleteUser";
import getApplication from "../../api-manager/utils/applications";
import OnOffButton from "@/components/OnOffButton";
import apiManager from "@/api-manager";
import NotificationStore from "@/components/NotificationPlugin/NotificationStore";
import WaitingForServer from "@/components/WaitingForServer";
import CreateNewDevice from "@/components/CreateNewDevice";

export default {
  name: "user-management",
  components: {
    OnOffButton,
    DeleteUser,
    SearchBox,
    Pagination,
    StatsCard,
    CreateNewUser,
    EnrollApplicationUser,
    WaitingForServer,
    CreateNewDevice
  },
  setup(props, context) {
    const userEnrolled = () => {
      enrollUserData.value.showEnrollUser = false;
      fetchUsers();
    };

    const search = ref("");
    const searched = ref("");
    const doSearch = () => {
      route.query.application_username__icontains = search.value;
      searched.value = search.value;
      if (searched.value) refreshUsers();
      else removeFilters("search");
    };

    const userCreated = () => {
      showAddUser.value = false;
      refreshUsers();
    };

    const users = ref([]);
    const totalPages = ref(1);
    const usersPage = ref(1);
    const totalUsers = ref(0);
    const applicationRadio = ref(null);
    const stateRadio = ref(null);
    const createDevice = ref(false)
    const fetchUsers = async () => {
      if (applicationRadio.value) {
        const application = applications.value.find((item) => item.pk === applicationRadio.value);
        stateRadio.value = application.isDeleted && stateRadio.value === null ? "DT" : stateRadio.value;
      }
      const response = await apiManager.getUsers({
        params: filters.value,
      });
      if (filters.value["export"] === "csv") {
        showWaitingForServerDialog.value = true;
      } else {
        totalPages.value = response.parsedData.total_pages;
        totalUsers.value = response.parsedData.total_items;
        users.value = [];
        for (const user of response.parsedData.users) {
          users.value.push({
            id: user.id,
            application_username: user.application_username,
            application_name: user.application_name,
            isActive: user.is_active,
            isEnrolled: user.is_enrolled,
            state: user.state,
            userID: `${user.user.username.slice(0, 3)}...${user.user.username.substr(user.user.username.length - 3)}`,
          });
        }
      }
    };

    const stats = ref({
      total: 0,
      deleted: 0,
      notEnrolled: 0,
      inactive: 0,
    });
    const getUserStats = async () => {
      // TODO Use new api
      let params = [
        {
          state: "ED",
          user__is_active: "True",
          storeIn: "total",
        },
        {
          // deleted users
          state: "DT",
          user__is_active: "False",
          storeIn: "deleted",
        },
        {
          // not enrolled
          state: "EG",
          user__is_active: "False",
          storeIn: "notEnrolled",
        },
        {
          //inactive
          state: "ED",
          user__is_active: "False",
          storeIn: "inactive",
        },
      ];
      for (let item of params) {
        const storeIn = item.storeIn;
        delete item.storeIn;
        const response = await apiManager.getUsers({
          params: {
            count: 1,
            ...item,
          },
        });
        if (response.status !== 200) {
          fetchErrorHandler(response.status, response.statusText, $options.name);
        } else stats.value[storeIn] = response.parsedData.users_cnt;
      }
    };

    const showAddUser = ref(false);
    const addNewUser = () => {
      showAddUser.value = true;
    };

    const router = context.root.$router;
    const userDetails = (user_id, isAllowed = true) => {
      let path = "users/user-details/?user_pk=" + user_id;
      if (isAllowed) router.push(path);
    };

    const showWaitingForServerDialog = ref(false);
    const refreshUsers = (exportCSV = false) => {
      filters.value = Object.assign({}, route.query);
      usersPage.value = 1;
      if (exportCSV === true) {
        filters.value["export"] = "csv";
      }
      fetchUsers();
    };

    const route = context.root.$route;
    const removeAll = ref(false);
    const removeFilters = (filter) => {
      if (filter === "search") {
        searched.value = "";
        search.value = "";
        delete route.query.application_username__icontains;
      }
      if (filter === "applicationID") {
        applicationRadio.value = null;
        delete route.query.application_id;
      }
      if (filter === "state") {
        stateRadio.value = null;
        delete route.query.state;
        delete route.query.user__is_active;
      }
      if (filter === "all" || Object.keys(route.query) == false) {
        searched.value = "";
        search.value = "";
        applicationRadio.value = null;
        stateRadio.value = null;
        delete route.query.state;
        delete route.query.user__is_active;
        delete route.query.application_id;
        delete route.query.application_username__icontains;
        removeAll.value = false;
      }
      refreshUsers();
      // window.scrollTo(0, 0);
    };

    const filters = ref({});
    const changePage = (page) => {
      if (filters.value["page"] !== page) {
        users.value = [];
        filters.value["page"] = page;
        fetchUsers();
      }
    };

    const enrollUserData = ref({
      showEnrollUser: false,
      currentApplicationUserPK: null,
    });
    const enrollUser = (application_user_pk) => {
      enrollUserData.value.currentApplicationUserPK = application_user_pk;
      createDevice.value = true
      fetchUsers();
    };

    const deleteUserData = ref({
      showDeleteUser: false,
      currentApplicationUserPK: null,
    });
    const deleteUser = (application_user_pk) => {
      deleteUserData.value.currentApplicationUserPK = application_user_pk;
      deleteUserData.value.showDeleteUser = true;
    };

    const userDeleted = () => {
      deleteUserData.value.showDeleteUser = false;
      if (users.value.length === 1) {
        filters.value["page"]--;
        usersPage.value--;
      }
      fetchUsers();
      NotificationStore.notify({
        message: "User deleted.",
        icon: "info",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "success",
      });
    };

    const operationFailed = (message) => {
      NotificationStore.notify({
        message: message ? message : "Operation Failed.",
        icon: "info",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "danger",
      });
    };

    const applications = ref([]);
    const fetchApplications = async (showDeleted = false) => {
      applications.value = await getApplication(
        showDeleted ? { active_only: false, page_size: 1000 } : { page_size: 1000 }
      );
    };

    const showDeletedApplications = ref(false);
    const showHideDeletedApplications = async () => {
      showDeletedApplications.value = !showDeletedApplications.value;
      await fetchApplications(showDeletedApplications.value);
    };

    const isViewerAdmin = computed(() => {
      return window.localStorage.getItem("adminGroups").includes("viewer_admins");
    });

    const onCloseCreateDevice = () => {
      createDevice.value = false;
      fetchUsers();
    }

    onMounted(() => {
      fetchApplications();
      fetchUsers();
      getUserStats();
    });

    onUpdated(() => {
      if (applicationRadio.value) {
        if (applicationRadio.value !== route.query.application_id) {
          route.query.application_id = applicationRadio.value;
          refreshUsers();
        }
      }
      if (stateRadio.value) {
        if (stateRadio.value !== route.query.state && stateRadio.value !== "AC") {
          route.query.state = stateRadio.value;
          route.query.user__is_active = "False";
          refreshUsers();
        }
        if (route.query.state !== "ED" && route.query.user__is_active !== "True" && stateRadio.value === "AC") {
          route.query.state = "ED";
          route.query.user__is_active = "True";
          refreshUsers();
        }
      }
      if (Object.keys(route.query).length) {
        removeAll.value = true;
      } else {
        removeAll.value = false;
      }
    });

    return {
      stats,
      search,
      totalUsers,
      users,
      totalPages,
      usersPage,
      userDetails,
      removeAll,
      searched,
      applicationRadio,
      applications,
      stateRadio,
      showAddUser,
      enrollUserData,
      userEnrolled,
      enrollUser,
      doSearch,
      changePage,
      showHideDeletedApplications,
      showDeletedApplications,
      userCreated,
      deleteUserData,
      deleteUser,
      userDeleted,
      operationFailed,
      addNewUser,
      refreshUsers,
      removeFilters,
      isViewerAdmin,
      showWaitingForServerDialog,
      createDevice,
      onCloseCreateDevice
    };
  },
};
</script>

<style lang="scss" scoped>
.is-active {
  .md-icon {
    margin-left: 16px;
    margin-right: 16px;
  }
}
</style>
